import { ICreateUserState } from './createUserContext';
import { CreateUserActionTypes, TCreateUserAction } from './createUserActions';

export const createUserReducer = (state: ICreateUserState, action: TCreateUserAction): ICreateUserState => {
	switch (action.type) {
		case CreateUserActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case CreateUserActionTypes.CHANGE_NAME:
			return {
				...state,
				name: action.payload.name,
			};
		case CreateUserActionTypes.CHANGE_SURNAME:
			return {
				...state,
				surName: action.payload.surName,
			};
		case CreateUserActionTypes.CHANGE_EMAIL:
			return {
				...state,
				email: action.payload.email,
			};
		case CreateUserActionTypes.CHANGE_PHONE_NUMBER:
			return {
				...state,
				phoneNumber: action.payload.phoneNumber,
			};
		case CreateUserActionTypes.SET_FETCHED_ROLES:
			return {
				...state,
				fetchedRoles: action.payload.roles,
			};
		case CreateUserActionTypes.SET_ROLE:
			return {
				...state,
				selectedRole: action.payload.role,
				fetchedCustomers: [],
				selectedCustomer: null,
				selectedCustomers: [],
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case CreateUserActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case CreateUserActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.selectedCustomer,
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case CreateUserActionTypes.SET_CUSTOMERS:
			return {
				...state,
				selectedCustomers: action.payload.selectedCustomers,
				fetchedRestaurants: [],
				selectedRestaurants: [],
			};
		case CreateUserActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.fetchedRestaurants,
			};
		case CreateUserActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.selectedRestaurants,
			};
		case CreateUserActionTypes.CHANGE_PASSWORD:
			return {
				...state,
				password: action.payload.password,
			};
		case CreateUserActionTypes.CHANGE_PASSWORD_CONFIRM:
			return {
				...state,
				passwordConfirm: action.payload.passwordConfirm,
			};
		case CreateUserActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateUserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateUserActionTypes.SHOW_ERROR_MODAL_WITH_INFO:
			return {
				...state,
				errorResponseData: action.payload.errorResponseData,
			};
		case CreateUserActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				name: '',
				surName: '',
				email: '',
				phoneNumber: '',
				selectedRole: null,
				fetchedCustomers: [],
				selectedCustomer: null,
				selectedCustomers: [],
				fetchedRestaurants: [],
				selectedRestaurants: [],
				password: '',
				passwordConfirm: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
